<template>
  <!--  <div class="filter-container" v-if="all_items.length || (!all_items.length && period !== 'همه')">-->
  <div class="filter-container">
    <div class="row justify-content-center">
      <div class="col-6">
        <p class="fw-bolder">فیلتر براساس دوره چرخه</p>
        <select class="form-select" v-model="period">
          <option value="همه">همه</option>
          <option v-for="(event, index) in events" :key="index" :value="event.name">{{ event.name }}</option>
        </select>
      </div>
    </div>
  </div>
 
  <div v-if="seconder_ban || approver_ban" @click="infoCancelledModal=true" class="d-flex justify-content-end mx-4">

    <a style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1 mb-2"
    > دلایل عدم
      تایید</a>
  </div>
  <center v-if="approver">
    <div class="alert alert-success w-25">
      تایید نهایی!
    </div>
  </center>
  <center v-if="all_items.length">
   
      <div class="alert alert-warning" style="width: 30vw;" v-if="status==1 && seconder_ban && !seconder && !producer">
        کاربرگ توسط مدیر عامل ؛ تایید نشد!
      </div>

      <div class="alert alert-warning" style="width: 40vw;"  v-if="status==2 && seconder_ban && !seconder && producer">
        این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!
      </div>

    
  </center>
  <center v-if="approver_ban && !seconder && !producer ">
    <div  @click="infoCancelledModal=true" class="alert alert-warning" style="width: 30vw;">
      کاربرگ توسط دبیر کمسیون بهره وری ؛ تایید نشد!
    </div>
  </center>
  <center  v-if="status==1 && producer && !seconder && !approver">
    <div  class="alert alert-info w-25">
      در انتظار تایید توسط مدیر عامل
    </div>
  </center>

  <center>
    <div v-if="producer && seconder && !approver" class="alert alert-info" style="width: 24vw;">
      در انتظار تایید توسط دبیر کمسیون بهره وری
    </div>
  </center>


  <center v-show="!all_items.length">
    <span>اطلاعاتی وجود ندارد</span>
  </center>

  <center   v-if="!producer && status==2">

          <span class="alert alert-info">
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
  </center>
  

  <div v-if="(all_items.length && status==1) || (all_items.length && status==2 && producer) " class="table-responsive">
    <table class="table table-striped bg-white" style="width: 70vw; ">
      <thead>
      <tr class="sticky-header">
        <th rowspan="2" style="width: 1vw;">ردیف</th>
        <th rowspan="2">اقدام پیشران</th>
        <th rowspan="2">مسئله</th>
        <th rowspan="2"> مأموریت</th>
        <th rowspan="2">کلان خدمت</th>
        <th colspan="3">زیرخدمت</th>
      </tr>
      <tr>
        <th>عنوان</th>
        <th>نهاده</th>
        <th class="nowrap">زنجیره نتایج</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in all_items" :key="item.id">
        <!-- Main Row -->
        <tr>
          <td :rowspan="item.sub_processes.length || 1">{{ index + 1 }}</td>
          <td :rowspan="item.sub_processes.length || 1">
            <ul style="padding: 0 2vw; list-style: persian;">
              <li v-for="(propulsionAction, propulsionActionIndex) in item.propulsion_basic_actions"
                  :key="propulsionActionIndex" class="my-2">
                {{ propulsionAction.title }}
              </li>
            </ul>
          </td>
          <td :rowspan="item.sub_processes.length || 1">{{ item.title }}</td>
          <td :rowspan="item.sub_processes.length || 1">{{ item.determining_missions }}</td>
          <td :rowspan="item.sub_processes.length || 1">{{ item.processes?.title }}</td>

          <template v-if="item.sub_processes.length">
            <td>{{ item.sub_processes[0].title }}</td>
            <td>
              <button
                  @click.prevent="openModal(item.sub_processes[0].id, item.title ,item.id)"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
            <td>
              <button
                  @click.prevent="openModalTwo(item.sub_processes[0].id, item.title, item.sub_processes[0].definition_of_outputs, item.sub_processes[0].intermediate_outcomes,item.id)"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
          </template>

          <template v-else>
            <td>--</td>
            <td>--</td>
            <td>--</td>
          </template>
        </tr>

        <!-- Additional Rows for Subprocesses -->
        <template v-if="item.sub_processes.length">
          <tr v-for="sub in item.sub_processes.slice(1)" :key="sub.id">
            <td>{{ sub.title }}</td>
            <td>
              <button
                  @click.prevent="openModal(sub.id, item.title ,item.id)"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
            <td>
              <button
                  @click.prevent="openModalTwo(
                      sub.id,
                      item.title,
                      sub.definition_of_outputs,
                      sub.intermediate_outcomes,
                      item.id
                  )"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
          </tr>
        </template>
      </template>
      </tbody>
    </table>
  </div>

  <InputsInformations :show_insert="show_insert&& not_show" :status="modalOne" @close="closeModal"
                      :title="title_process" :id="subProcessId" :issue_id="issue_id"
  />
  <ChainInformations :show_insert="show_insert&& not_show" :intermediate_outcomes="intermediate_outcomes"
                     :definition_of_outputs="definition_of_outputs" :status="modalTwo" @close="closeModal"
                     :title="title_process" :id="subProcessId" :issue_id="issue_id"/>
  <hr class="m-2">
<center  class=" d-flex  align-items-center justify-content-center">
<button v-if="status==2 && all_items.length && producer" @click.prevent="exportWord" class="btn btn-primary btn-submit-1 mx-2">خروجی Word</button>
  
<button v-if="status==1 && all_items.length" @click.prevent="exportWord" class="btn btn-primary btn-submit-1 mx-2">خروجی Word</button>

<center v-if="all_items.length && status==2 && producer  && !seconder" class=" d-flex  align-items-center justify-content-center">
    
    
    <a 
       style="margin-top: -.1vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green"
        class="btn btn-primary btn-submit-1 "
>
      <div >

        <span @click="acceptComplete" >تایید </span>
        

      </div>

      
    </a>

  

    <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal"
         style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>اخطار</p>
        <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
      </div>
      <div>
        <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">
            برگشت
          </button>
          <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
        </div>
      </div>
    </div>
    <a v-if="!$cookies.isKey('type_2') && not_show"
       style="margin-top: -0.1vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
       class="btn btn-primary btn-submit-1 "
       @click="acceptComplete2"
    >
      <div v-if="!status_loading2">
        <span>عدم تایید</span>
      </div>

      <div v-else>
        <div class="loader-line"></div>

      </div>
    </a>
  </center>




    <center v-if="all_items.length && status==1 && !producer && !seconder" class=" d-flex  align-items-center justify-content-center">
    
    <a v-if="status==1 && !producer && !seconder"
       
        
        style="width: 12vw;  margin-top: -.1vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green"
        class="btn btn-primary btn-submit-1 "


    >
      

      <div v-if="status==1 && !producer">

        <span @click="acceptCompleteModal=true" > ارائه جهت تایید مدیر عامل</span>

      </div>

      
    </a>



    <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal"
         style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>اخطار</p>
        <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
      </div>
      <div>
        <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">
            برگشت
          </button>
          <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
        </div>
      </div>
    </div>
    <a v-if="!$cookies.isKey('type_2') && not_show"
       style="margin-top: -0.1vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
       class="btn btn-primary btn-submit-1 "
       @click="acceptComplete2"
    >
      <div v-if="!status_loading2">
        <span>عدم تایید</span>
      </div>

      <div v-else>
        <div class="loader-line"></div>

      </div>
    </a>
  </center>

 </center>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal"
       style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelledModal=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
      <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{ textAlert }}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4" class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>
</template>

<script>
import InputsInformations from "@/components/Impact_Assessment/Input/InputsInformations.vue";
import ChainInformations from "@/components/Impact_Assessment/Input/ChainInformations.vue";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  components: {ChainInformations, InputsInformations},
  data() {
    return {
      period: 'همه',
      events: [],
      all_items: [],
      definition_of_outputs: [],
      intermediate_outcomes: [],
      approver:false,
      producer:false,
      seconder:false,
      notRecord: false,
      modalOne: false,
      modalTwo: false,
      title_process: '', // Initialize these variables
      subProcessId: null,
      issue_id:null,
      status_show: false,
      showReSubmit: false,
      seconder_ban: false,
      approver_ban: false,
      infoCancelledModal: false,
      status_approver: false,
      status_seconder_step: false,
      status_seconder: false,
      isWrite: false,
      not_show: true,
      show_insert: false,
      status_loading: false,
      status_loading2: false,
      infoCancelled: false,
      acceptCompleteModal: false,
      is_try: false,
      status:1,
      stop: false,
      textAlert: '',
      text_info: '',
    }
  },
  methods: {
    exportWord() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`); // اضافه کردن توکن

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/impact-assessment/get_word`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.download_url) {
              // باز کردن لینک در تب جدید
              window.open(result.download_url, '_blank');
            } else {
              throw new Error('Download URL not provided');
            }
          })
          .catch(error => {
            toast.error('خطا در دریافت فایل!');
          });
    },
    openModal(id, title,issue_id) {
      this.modalOne = true;
      this.title_process = title; // Use title_process here
      this.subProcessId = id;
      this.issue_id=issue_id;
    },
    openModalTwo(id, title, definition_of_outputs, intermediate_outcomes,issue_id) {
      
      this.modalTwo = true;
      this.title_process = title; // Use title_process here
      this.subProcessId = id;
      this.definition_of_outputs = definition_of_outputs
      this.intermediate_outcomes = intermediate_outcomes
      this.issue_id=issue_id;

    },
    closeModal() {
      this.modalOne = false;
      this.modalTwo = false;
      this.all();
    },
    all() {
      if (this.stop) return false;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('period', this.period)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/completed_problems_Impact_Assessment`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.data.events) {
              this.events = result.data.events
            }
            if (result.data.completed_problems && result.data && result.data.completed_problems.details) {
              this.all_items = result.data.completed_problems.details
            }
            if (result.data.completed_problems && result.data.completed_problems.count === 0) {
              this.notRecord = true
            }


          })
          .catch();
    },
    result_company() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/result_company`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.producer=response.complete.producer
            this.seconder=response.complete.seconder
            this.approver=response.complete.approver
            this.seconder_ban=response.complete.seconder_ban
            this.approver_ban=response.complete.approver_ban
            this.status=response.status
            this.textAlert=response.complete.text
            this.all()
          })
          .catch();
    },
    setShow() {
      if (this.$cookies.isKey('type_2')) {
        if (this.status_show === false) {
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete() {
      this.acceptCompleteModal = false

      

      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
         
        }
      }
      if (this.seconder_ban || this.approver_ban) {
        this.showReSubmit = true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/update_complate`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.result_company()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    
    acceptComplete2() {

      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.status==1) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },

    acceptComplete4() {
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/update_complate`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.result_company()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete3() {
      if(this.text_info==''){
        toast.error('دلیل عدم تایید الزامی است')
         return;
      }
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/impact-assessment/update_complate`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/update_complate`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading2 = false
              this.result_company()
            }
            this.infoCancelled = false

          })
          .catch();
    },
  },
  watch: {
    period: function () {
      this.result_company()
    },
  },
  mounted() {
    this.result_company()

  },
}

</script>
<style scoped>
.filter-container {
  padding: 0 20vw;
  margin: 3vw auto
}
</style>